import React, { memo, FC } from "react";
import ReusableAccordian from "../ReusableAccordion";
import PleaseNote from "../PleaseNote";
import JambInput from "./JambInput";
import JambOptions from "./JambOptions";
import { RowLayout } from "../../util/accordianStyles";
import useJambSelector from "./useJambSelector";

const JambAccordian: FC = () => {
  const {
    options,
    type,
    checkMark,
    variant,
    handleClick,
    fractionValueJamb,
    doorType,
    direction,
    showCustomInput,
    jamb,
  } = useJambSelector();

  return (
    <ReusableAccordian
      accordionName="jamb"
      heading="Overall Jamb Width"
      secondaryHeading="Select jamb width (inches)"
      colOrRow="col"
    >
      {doorType === "Swing" && !direction && (
        <PleaseNote notes="Select a Swing Direction to view Jamb Options" />
      )}

      <RowLayout>
        <JambOptions
          options={options}
          handleClick={handleClick}
          type={type}
          variant={variant}
          checkMark={checkMark}
        />

        {showCustomInput && (
          <JambInput
            fraction={fractionValueJamb}
            jamb={
              jamb?.includes("Custom")
                ? ""
                : jamb?.split(" ")[0]
                ? jamb.split(" ")[0]
                : ""
            }
          />
        )}
      </RowLayout>
    </ReusableAccordian>
  );
};

export default memo(JambAccordian);
